
































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class AppHeaderBackWithTitle extends Vue {
  @Prop({ default: true, type: Boolean })
  private showBtn!: boolean;
}
